import { API_STATUS } from "../../../constants/apiStatus";

export const dietPreferencesSliceInitialState = {
  preferences: null,
  allOptions: [],
  apiStatus: {
    getPreferences: API_STATUS.IDLE,
    updatePreferences: API_STATUS.IDLE,
    getAllOptions: API_STATUS.IDLE,
  },
  error: null,
};
